import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getBusinessDaysReportFilteredData } from "../services/businessDaysReportServices";

export default function FilterModal({ onClose, data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // Filter Data
  const [filterCriteria, setFilterCriteria] = useState({
    BranchName: "",
    OpendBy: "",
    ClosedBy: "",
  });

  const handleFilterBusinessDays = (e) => {
    e.preventDefault();
    const filteredResult = data.filter((item) => {
      const { OpendBy , BranchName , ClosedBy} = filterCriteria;

      let filterOpendBy = true;
      let filterClosedBy = true;
      let filterBranchName = true;

      if (OpendBy) {
        filterOpendBy = item?.OpenedBy?.toLowerCase().includes(OpendBy.toLowerCase());
      }
      if (BranchName) {
        filterBranchName = item?.BranchName?.toLowerCase().includes(BranchName.toLowerCase());
      }
      if (ClosedBy) {
        filterClosedBy = item?.ClosedBy?.toLowerCase().includes(ClosedBy.toLowerCase());
      }

      return (
        filterOpendBy &&
        filterClosedBy &&
        filterBranchName
      );

    });

    setFilteredData(filteredResult);
    onClose();
    dispatch(getBusinessDaysReportFilteredData(filteredResult));
  };

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.reports.business_reports.filter")}
        modalContent={
          <Box p={4}>
            <form onSubmit={handleFilterBusinessDays}>
              <Stack spacing={6}>
                <Input
                  label={t("pages.reports.reports_tables.branch")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.branch")}
                  name="BranchName"
                  value={filterCriteria.BranchName}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      BranchName: e.target.value,
                    })
                  }
                />
                <Input
                  label={t("pages.reports.reports_tables.opendby")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.opendby")}
                  name="OpendBy"
                  value={filterCriteria.OpendBy}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      OpendBy: e.target.value,
                    })
                  }
                />

                <Input
                  label={t("pages.reports.reports_tables.closedby")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.closedby")}
                  name="ClosedBy"
                  value={filterCriteria.ClosedBy}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      ClosedBy: e.target.value,
                    })
                  }
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
}
